export const IMinimapConfigProvider = Symbol('IMinimapConfigProvider');
//# sourceMappingURL=interface.js.map